import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { DateTime } from 'luxon';
import { ChancenwerkUser } from '../../master-data-management/users/entities/ChancenwerkUser.js';
import { MeetingNote } from './meeting-notes.js';

/**
 * @entity QuarterNoteQuestion
 */
@Entity()
export class QuarterNoteQuestion extends MongoEntity {
  public static override _class = 'QuarterNoteQuestion';
  public static override _collectionName = 'note-questions';

  @Field(() => String)
  public meetingNoteID: Maybe<string>;

  @DataLoadedField(() => MeetingNote, ({ meetingNoteID }) => meetingNoteID)
  public meetingNote: Maybe<MeetingNote>;

  @Field(() => String)
  public question: Maybe<string>;

  @Field(() => String)
  category: Maybe<string>;

  @Field(() => String)
  year: Maybe<string>;

  @Field(() => String)
  public anwser: Maybe<string>;

  @Field(() => DateTime)
  public answerDate: Maybe<DateTime>;

  @Field(() => String)
  public personAnsweredID: Maybe<string>;

  @DataLoadedField(() => ChancenwerkUser, ({ personAnsweredID }) => personAnsweredID)
  public personAnswered: Maybe<ChancenwerkUser>;

  // Only for product questions
  @Field(() => Boolean)
  isRunningGood: Maybe<boolean>;

  @Field(() => String)
  reason: Maybe<string>;

  @Field(() => DateTime)
  public plannedAt: Maybe<DateTime>;
}
